import { SVGAttributes } from "react";

export default (props: SVGAttributes<any>) => {
  return (
    <>
      <svg {...props} width="6" height="9" viewBox="0 0 6 9" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M3.53705 4.3335L0.882689 1.61948C0.595093 1.32542 0.595093 0.848101 0.882689 0.554041C1.17029 0.259981 1.63711 0.259981 1.9247 0.554041L5.12994 3.83132C5.40156 4.10904 5.40156 4.55866 5.12994 4.83567L1.9247 8.11295C1.63711 8.40701 1.17029 8.40701 0.882689 8.11295C0.595093 7.81889 0.595093 7.34158 0.882689 7.04751L3.53705 4.3335Z"
          fill="#A3B0CC"
        />
      </svg>
    </>
  );
};
